import {isPresent} from '../../../common/utils.js'
import apiverson from '../../../common/apiverson.js'
import ButtonPrimary from '../../../common/components/Button/ButtonPrimary.js'
import {
  returnOrderCodeSelector,
  setReturnOrderCode,
} from '../../../data/returnOrderCodes.js'
import TextInput from '../Common/TextInput.js'
import Column from '../Common/Column.js'
import FormList from '../Common/FormList.js'
import FormListItem from '../Common/FormListItem.js'
import {
  formSelector,
  getState,
  onlyIfAutoForm,
  updateForm,
  useSelector,
} from '../../../store.js'
import {navigate} from '../../../common/location.js'
import {
  RETURN_ORDER_CODES,
  SETTINGS,
} from '../../../common/constants/SettingsPanels.js'
import {buildPath} from '../../../common/querystring.js'

const RETURN_ORDER_CODE_FORM = 'return_order_code_form'

function setupReturnOrderCodeForm({returnOrderCodeID}) {
  const code = returnOrderCodeSelector(getState(), {returnOrderCodeID})

  return {
    formName: RETURN_ORDER_CODE_FORM,
    initialForm: {
      id: code ? code.id : null,
      code: code ? code.code : '',
      description: code ? code.description : '',
      isSaving: false,
      serverError: null,
    },
  }
}

function updateCodeForm(updates) {
  updateForm(RETURN_ORDER_CODE_FORM, updates)
}

function codeFormSelector(state) {
  return formSelector(state, {formName: RETURN_ORDER_CODE_FORM})
}

function errorsSelector(state) {
  const form = codeFormSelector(state)
  const errors = {}

  if (!form) {
    return errors
  }

  if (form.codeHasChanged && !isPresent(form.code)) {
    errors.code = 'Code is required'
  }

  if (!isPresent(form.code)) {
    errors.preventSave = true
  }

  return errors
}

export async function saveReturnOrderCode() {
  try {
    const {id, code, description} = codeFormSelector(getState())
    const {code: originalCode} = id
      ? returnOrderCodeSelector(getState(), {returnOrderCodeID: id})
      : {code: null}

    const data = {
      code,
      description,
    }

    const {json} = originalCode
      ? await apiverson.put(
          buildPath(['return_order', 'code', originalCode]),
          data,
        )
      : await apiverson.post(buildPath(['return_order', 'code']), data)

    setReturnOrderCode(json)

    navigate([SETTINGS, RETURN_ORDER_CODES])
  } catch (err) {
    updateCodeForm({
      serverError: err.message,
    })
  }
}

function ReturnOrderCodeForm({form}) {
  const errors = useSelector(errorsSelector)

  return (
    <form
      className="wrap--row margin-top-30"
      onSubmit={(event) => {
        event.preventDefault()

        saveReturnOrderCode()
      }}
    >
      <Column className="medium-6">
        <div>{form.serverError}</div>
        <FormList>
          <FormListItem>
            <TextInput
              name="code"
              label="Code"
              required
              value={form.code}
              errorMessage={errors.code}
              onChange={(event) =>
                updateCodeForm({
                  code: event.target.value,
                  hasChangedCode: true,
                })
              }
            />
          </FormListItem>
          <FormListItem>
            <TextInput
              name="description"
              label="Description"
              value={form.description}
              errorMessage={errors.description}
              onChange={(event) =>
                updateCodeForm({
                  description: event.target.value,
                  hasChangedDescription: true,
                })
              }
            />
          </FormListItem>
        </FormList>
        <div className="divider--top padding-top-15">
          <ButtonPrimary
            type="submit"
            size="std"
            isDisabled={errors.preventSave || form.isSaving}
            isLoading={form.isSaving}
          >
            {form.id ? 'Save' : 'Create'}
          </ButtonPrimary>
          <a
            className="btn btn--secondary"
            href={'#' + buildPath([SETTINGS, RETURN_ORDER_CODES])}
          >
            Cancel
          </a>
        </div>
      </Column>
    </form>
  )
}

export default onlyIfAutoForm(ReturnOrderCodeForm, setupReturnOrderCodeForm)
